import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = {
  key: 0,
  class: "sec-main highlightD-main pb-0"
}
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = { class: "breadcrumb-item" }
const _hoisted_10 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = { class: "row mb-4" }
const _hoisted_12 = { class: "col-sm-10 mx-auto list-content" }
const _hoisted_13 = {
  key: 0,
  class: "list-banner"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "board bg-white" }
const _hoisted_16 = { class: "head-row flex-grow-1 text-primary" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "活動介紹", -1)
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "所屬單位", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "frce mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:void(history.go(-1))",
    class: "btn-anchor back",
    aria: "返回前頁"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "返回前頁")
  ])
], -1)
const _hoisted_22 = {
  key: 1,
  class: "recommend-sec"
}
const _hoisted_23 = { class: "container-lg" }
const _hoisted_24 = { class: "col-11 col-md-10 mx-auto" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3 text-primary" }, "看其他亮點成果", -1)
const _hoisted_26 = { class: "row row-cols-1 flex-nowrap row-cols-md-3 cols-list highlight-list" }
const _hoisted_27 = { class: "event-item bg-white h-100 p-0" }
const _hoisted_28 = { class: "event-card-logo" }
const _hoisted_29 = { class: "event-card-info p-3 border-top" }
const _hoisted_30 = { class: "event-card-date info-text mb-2" }
const _hoisted_31 = { class: "event-card-cate text-primary mb-2" }
const _hoisted_32 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("nav", _hoisted_5, [
                _createElementVNode("ol", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/",
                      title: "首頁",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("首頁")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/list",
                      title: "活動消息",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("活動消息")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: "/achievements",
                      title: "亮點成果",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("亮點成果")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.item.title), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.item.file2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: _ctx.item.file2.path,
                        class: "img-fluid",
                        alt: _ctx.item.title
                      }, null, 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.item.title), 1),
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("p", {
                    class: "editor-html",
                    innerHTML: _ctx.item.content
                  }, null, 8, _hoisted_19),
                  _hoisted_20,
                  _createElementVNode("p", null, _toDisplayString(_ctx.item.organizer), 1)
                ]),
                _hoisted_21
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.others.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.others, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "col align-self-stretch mb-4"
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_router_link, {
                        to: {name: 'achievements-detail', params: { id: item.id }},
                        title: "看其他亮點成果",
                        class: "foo: false"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", {
                              class: "bg-wrapper",
                              style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-highlight.png') + ')')
                            }, null, 4)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, _toDisplayString(item.date), 1),
                            _createElementVNode("div", _hoisted_31, _toDisplayString(item.title), 1),
                            _createElementVNode("div", {
                              class: "h5 event-card-title limitLine mb-2 editor-html",
                              innerHTML: item.content
                            }, null, 8, _hoisted_32)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}